<template>
  <div>
    <RangeSelector :submit-method="loadAllData"/>
<!--    <button @click="checker">CHECK</button>-->
    <!-- Tabs -->
    <div class="tabs">
<!--      <button-->
<!--          class="brutalist-button"-->
<!--          :class="{ active: activeTab === 'processed' }"-->
<!--          @click="changeTab('processed'); fetchRequestData(true)"-->
<!--      >-->
<!--        <div class="ms-logo">-->
<!--          Processed-->
<!--        </div>-->
<!--      </button>-->
<!--      <button-->
<!--          class="brutalist-button"-->
<!--          :class="{ active: activeTab === 'pending' }"-->
<!--          @click="changeTab('pending'); fetchRequestData(false)"-->
<!--      >-->
<!--        <div class="ms-logo">-->
<!--          Pending-->
<!--        </div>-->
<!--      </button>-->

      <div class="radio-inputs">
        <label class="radio">
          <input
              type="radio"
              name="radio"
              id="approved"
              value="processed"
              v-model="activeTab"
              @change="handleTabChange"
          />
          <span class="name">Processed</span>
        </label>

        <label class="radio">
          <input
              type="radio"
              name="radio"
              id="denied"
              value="pending"
              v-model="activeTab"
              @change="handleTabChange"
          />
          <span class="name">Pending</span>
        </label>
      </div>
    </div>

    <!-- Desktop View -->
    <div v-if="isDesktop && activeTab === 'processed'" class="desktop-view">
      <vue-good-table
          :columns="columns"
          :rows="filteredRows"
          :loading="loading"
          style="margin-top: 20px;"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'image_id'">
            <img
                src="../assets/img/no-image.png"
                v-gallery
                :data-large="image + 'getImageByRequestID/' +props.row.id"
                alt="Product Image"
                width="20"
                height="20"
            />
          </div>
<!--          <div v-else-if="props.column.field === 'actions'">-->
<!--            <button-->
<!--                class="button"-->
<!--                style="margin-left: 30px;"-->

<!--            >-->
<!--              <svg viewBox="0 0 448 512" class="svgIcon">-->
<!--                <path-->
<!--                    d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path>-->
<!--              </svg>-->
<!--            </button>-->
<!--          </div>-->
        </template>
      </vue-good-table>
    </div>
    <div v-if="isDesktop && activeTab === 'pending'" class="desktop-view">
      <vue-good-table
          :columns="columns"
          :rows="filteredRows2"
          :pagination-options="{
            enabled: true,
            mode: 'pages'
          }"
          :loading="loading"
          style="margin-top: 10px;"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'image_id'">
            <img
                src="../assets/img/no-image.png"
                v-gallery
                :data-large="image + 'getImageByRequestID/' +props.row.id"
                alt="Product Image"
                width="20"
                height="20"
            />
          </div>
          <div v-else-if="props.column.field === 'actions'">
            <button
                class="bin-button"
                @click.prevent="denyRequest(props.row)"
            >
              <svg
                  class="bin-top"
                  viewBox="0 0 39 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="5" x2="39" y2="5" stroke="white" stroke-width="4"></line>
                <line
                    x1="12"
                    y1="1.5"
                    x2="26.0357"
                    y2="1.5"
                    stroke="white"
                    stroke-width="3"
                ></line>
              </svg>
              <svg
                  class="bin-bottom"
                  viewBox="0 0 33 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_8_19" fill="white">
                  <path
                      d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"
                  ></path>
                </mask>
                <path
                    d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"
                    fill="white"
                    mask="url(#path-1-inside-1_8_19)"
                ></path>
                <path d="M12 6L12 29" stroke="white" stroke-width="4"></path>
                <path d="M21 6V29" stroke="white" stroke-width="4"></path>
              </svg>
            </button>
<!--            <button-->
<!--                class="button"-->
<!--                @click.prevent="denyRequest(request)"-->
<!--            >-->
<!--              <svg viewBox="0 0 448 512" class="svgIcon">-->
<!--                <path-->
<!--                    d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path>-->
<!--              </svg>-->
<!--            </button>-->
          </div>
        </template>

      </vue-good-table>
    </div>

    <!-- Mobile View -->
    <div v-if="!isDesktop">
      <div class="cards-list">
        <div v-if="!activeRequests.length && activeTab === 'processed'" class="no-data-card">
          <h3>No Processed Requests :)</h3>
        </div>
        <div v-if="!activeRequests.length && activeTab === 'pending'" class="no-data-card">
          <h3>No Pending Requests :(</h3>
        </div>

<!--        <div v-else class="cards" v-for="(request, index) in activeRequests" :key="index">-->
<!--          &lt;!&ndash; Button div at the top-right corner &ndash;&gt;-->
<!--          <div class="iconss top-right">-->
<!--            <a-->
<!--                class="btns"-->
<!--                href="#"-->
<!--                v-gallery-->
<!--                :data-large="image + 'getImageByRequestID/' + request.id"-->
<!--                @click.prevent-->
<!--            >-->
<!--              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="svg-icons">-->
<!--                <path fill="none" stroke="currentColor" stroke-width="2" d="M4 8h16v12H4z"></path>-->
<!--                <circle fill="none" stroke="currentColor" stroke-width="2" cx="12" cy="14" r="3"></circle>-->
<!--                <path fill="none" stroke="currentColor" stroke-width="2" d="M8 6l2-2h4l2 2"></path>-->
<!--              </svg>-->
<!--            </a>-->

<!--            <a-->
<!--                v-if="activeTab === 'pending'"-->
<!--                class="btns" href="#"-->
<!--                @click.prevent="denyRequest(request)"-->
<!--            >-->
<!--              <svg class="svg-icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"-->
<!--                   fill="red">-->
<!--                <path d="M3 6h18"></path>-->
<!--                <path d="M19 6l-1 14c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1L5 6"></path>-->
<!--                <path d="M10 11v6"></path>-->
<!--                <path d="M14 11v6"></path>-->
<!--                <path d="M8 6V4c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v2"></path>-->
<!--              </svg>-->
<!--            </a>-->
<!--          </div>-->

<!--          &lt;!&ndash; Texts &ndash;&gt;-->
<!--          <div class="texts">-->
<!--            <div class="amount-and-status">-->
<!--              <h1>K {{ request.amount }}</h1>-->
<!--              <h1 :class="`badge`+badgeStatus(request.status)"-->
<!--                  style="margin-left: 60px; border: solid 1px white; padding: 2px; background-color: white; border-radius: 5px; font-size: 15px"-->
<!--              >-->
<!--                {{ request.status }}-->
<!--              </h1>-->
<!--            </div>-->
<!--            <h2 class="subtitle">USER : {{ request.request_by }}</h2>-->
<!--            <h2 class="subtitle">DATE : {{ request.requested_date }}</h2>-->
<!--            <h2 class="subtitle">ACCOUNT TYPE : {{ request.provider }}</h2>-->
<!--            <h2 class="subtitle">ACCOUNT : {{ request.reference }}</h2>-->
<!--            <h2 class="subtitle">REASON : {{ request.reason }}</h2>-->
<!--          </div>-->
<!--        </div>-->

        <div class="row gap-1" style="width: 100%">
          <div
              style="width: 94%"
              class="card col-md-4"
              v-for="(item, index) in activeRequests"
              :key="index"
          >
            <h1
                :class="`badge`+badgeStatus(item.status)"
            >
              {{ item.status }}
            </h1>
            <div>
              <div class="d-flex flex-row justify-content-between">
                <div class="d-flex flex-column mx-3" >
                  <img src="../assets/img/no-image.png" v-gallery
                       :data-large="image+`getImageByRequestID/${item.id}`" alt="Product Image" width="30"
                       height="30"/>
                  <span class="text-secondary " style="font-size: 12px">(Click to View)</span>
                </div>
                <div class="d-flex flex-column">
<!--                  <h1 :class="`badge`+badgeStatus(item.status)"-->
<!--                      style="margin-left: 60px; border: solid 1px white; padding: 2px; background-color: white; border-radius: 5px; font-size: 15px"-->
<!--                  >-->
<!--                    {{ item.status }}-->
<!--                  </h1>-->
                  <p>{{ item.subType }}</p>
                  <p>{{ item.requestedWallet }}</p>
                </div>
                <a @click="acceptRequestOnlyExpense(item)">
                  <font-awesome-icon icon="money-bill"/>
                </a>
              </div>
              <div class="product-info">
                <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                <span v-if="item.reference">{{ item.reference }}<br>({{ item.provider }})</span>
              </div>
            </div>
            <div class="card-body d-flex flex-column">
              <span class="card-text mb-1" v-if="item.reason !== null"><strong>Subtype:</strong> {{ item.subtype }}</span>
              <!--              <span class="fw-bolder mb-1" style="font-size: 20px" >{{ item.request_by }}</span>-->
              <span class="fw-bolder mb-1" style="font-size: 20px" >{{ item.requestedBy }}</span>
<!--              <span class="card-text mb-1"><strong>Department:</strong> {{ item.department }}</span>-->
              <span class="card-text mb-1" v-if="item.reason !== null"><strong>Reason:</strong> {{ item.reason }}</span>
              <span class="card-text mb-1" v-if="item.decline_reason !== null"><strong>Declined reason:</strong> {{ item.decline_reason }}</span>
              <span class="card-text"><strong>Date:</strong> {{ item.requested_date }}</span>
              <span class="card-text my-2"></span>
              <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
            </div>
            <div class="d-flex flex-row justify-content-evenly" v-if="activeTab === 'pending'">
              <button type="button" class="btn text-center w-50 btn-danger" @click="denyRequest(item)">Deny</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import axios from "axios";
import {Storage} from "@/Services/Storage";
import RangeSelector from "@/components/layout/RangeSelector.vue";
import {mapGetters} from "vuex";
import Swal from "sweetalert2";

export default {
  components: {
    RangeSelector,
  },
  data() {
    return {
      user: {
        Username: 'Null',
        id: 'Null',
        office: '',
        wallets: [],
      },
      activeTab2: 'USER',
      image: ticketApi2,
      activeTab: "processed",
      view: "deck", // Current view: deck or list
      isDesktop: window.innerWidth > 768, // Desktop or mobile view
      loading: false, // For showing loading indicator
      processedRequests: [],
      pendingRequests: [],
      columns: [
        {label: "User", field: "request_by", sortable: true},
        {label: "Amount (K)", field: "amount", sortable: true},
        {label: "Account", field: "reference", sortable: true},
        // {label: "SUBTYPE", field: "subtype", sortable: true},
        {label: "Account Type", field: "provider", sortable: true},
        {label: "Date", field: "requested_date", sortable: true},
        {label: "Status", field: "status", sortable: true},
        {label: "Reason", field: "reason", sortable: true},
        {label: "Image", field: "image_id", sortable: true},
        {label: "Actions", field: "actions", sortable: false},

      ],
      item: {
        image_id: '',
      },
    };
  },
  computed: {
    ...mapGetters({getGlobalDateRange: "getGlobalDateRange"}),
    filteredRows() {
      return this.processedRequests;
    },
    filteredRows2() {
      return this.pendingRequests;
    },
    activeRequests() {
      return this.activeTab === "processed"
          ? this.processedRequests
          : this.pendingRequests;
    },
  },
  methods: {
    checker() {
      console.log(this.activeRequests);
    },
    handleTabChange() {
      this.fetchRequestData(this.activeTab === 'processed');
    },
    badgeStatus(status) {
      switch (status) {
        case 'DECLINED':
          return ` bg-danger`;
        case 'APPROVED':
          return ` bg-success`;
        default:
          return ` bg-warning`;
      }
    },
    async fetchRequestData(processed) {
      this.$utils.showLoading();
      try {
        const username = await Storage.getCurrentUser();
        const response = await axios.get(
            `${ticketApi2}statistics/getExpensesByUser?user=${username.username}&processed=${processed}&from=${this.getGlobalDateRange.from}&to=${this.getGlobalDateRange.to}`
        );
        if (processed) {
          this.processedRequests = response.data;
        } else {
          this.pendingRequests = response.data;
        }
      } catch (error) {
        responses.throwErr(error);
        console.error(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    loadAllData() {
      this.fetchRequestData(false); // Load pending requests
      this.fetchRequestData(true); // Load processed requests
    },
    changeTab(tab) {
      this.activeTab = tab;
      // this.fetchRequestData(tab === "processed");
    },
    async denyRequest(request) {
      console.log(request);
      return Swal.fire({
        icon: `question`,
        title: `Deny Reason`,
        input: `textarea`,
        showCloseButton: true,
        showCancelButton: true,
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async (inputValue) => {
          if (!inputValue) return Swal.showValidationMessage(`Reason is Required`);
          const id = request.id;
          const type = 'USER';
          const declinedBy = this.user.username;
          const url = `${ticketApi2}decline`;

          const requestBody = {
            id: id,
            type: type,
            reason: inputValue,
            declinedBy: declinedBy,
          };
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Declined Successfully`);
            return this.fetchRequestData(false); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Accept Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split("\n")[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split("\n").slice(1, 4).join("\n"); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;

              // Display the formatted error message in SweetAlert
              return Swal.showValidationMessage(formattedError);
            }
          }
        },
      });
    },
    async getLoggedInUser() {
      try {
        this.user = await Storage.getCurrentUser();
        let wallets = this.user.wallets;
        let defaultWallet = null;
        if (wallets && wallets.length > 0) {
          let wallet = wallets.find(wal => wal.primary);
          if (wallet) defaultWallet = wallet.id;
        }
        this.$store.commit(`setSelectedWallet`, defaultWallet);
        this.selectedWallet = defaultWallet;
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },
  },
  async mounted() {
    this.user = await Storage.getCurrentUser();

    this.fetchRequestData(1); // Processed requests
    this.fetchRequestData(0); // Pending requests
    this.changeTab(this.activeTab);

    // Listen for window resize to determine desktop or mobile view
    window.addEventListener("resize", () => {
      this.isDesktop = window.innerWidth > 768;
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.isDesktop = window.innerWidth > 768;
    });
  },
};
</script>

<style scoped>
/* Tabs */
html, body {
  height: 90%;
  overflow: auto;
}
.tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tabs {
  margin: 0 10px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tabs {
  color: white;
}

/* Desktop View (vue-good-table styling) */
.desktop-view {
  padding: 20px;
  width: 90%;
  margin: 0 auto;

}
.desktop-view, .cards-list {
  max-height: 80vh; /* Adjust as needed */
  overflow-y: auto;
}

.no-data-card {
  background: #f8f8f8;
  padding: 20px;
  border: 1px solid #ccc;
  text-align: center;
}

.card-list .card {
  position: static;
  width: 100%;
  height: auto;
  margin: 10px 0;
}

.controls button {
  margin: 0 10px;
  padding: 10px 20px;
  border: none;
  background-color: #f76b1c;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgb(20, 20, 20);
  border: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.164);
  cursor: pointer;
  transition-duration: .3s;
  overflow: hidden;
  position: relative;
}

.svgIcon {
  width: 12px;
  transition-duration: .3s;
}

.svgIcon path {
  fill: white;
}

.button:hover {
  width: 100px;
  border-radius: 50px;
  transition-duration: .3s;
  background-color: rgb(255, 69, 69);
  align-items: center;
}

.button:hover .svgIcon {
  width: 50px;
  transition-duration: .3s;
  transform: translateY(60%);
}

.button::before {
  position: absolute;
  top: -20px;
  content: "Delete";
  color: white;
  transition-duration: .3s;
  font-size: 2px;
}

.button:hover::before {
  font-size: 13px;
  opacity: 1;
  transform: translateY(30px);
  transition-duration: .3s;
}

.brutalist-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 105px;
  height: 60px;
  background-color: #000;
  color: #fff;
  text-decoration: none;
  font-family: Arial, sans-serif;
  font-weight: bold;
  border: 3px solid #fff;
  outline: 3px solid #000;
  box-shadow: 6px 6px 0 #00a4ef;
  transition: all 0.1s ease-out;
  padding: 0 15px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  margin: 5px;
}

.brutalist-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
  );
  z-index: 1;
  transition: none;
  /* Initially hide the pseudo-element */
  opacity: 0;
}

@keyframes slide {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.brutalist-button:hover::before {
  /* Show the pseudo-element on hover */
  opacity: 1;
  animation: slide 2s infinite;
}

.brutalist-button:hover {
  transform: translate(-4px, -4px);
  box-shadow: 10px 10px 0 #000;
  background-color: #000;
  color: #fff;
}

@keyframes slide {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.brutalist-button:active {
  transform: translate(4px, 4px);
  box-shadow: 0px 0px 0 #00a4ef;
  background-color: #fff;
  color: #000;
  border-color: #000;
}

/* Rest of the CSS remains the same */

.ms-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  width: 100%;
  height: 100%;
  margin-right: 8px;
  flex-shrink: 0;
  transition: transform 0.2s ease-out;
  position: relative;
  z-index: 1;
}

.brutalist-button:hover .ms-logo {
  transform: rotate(-10deg) scale(1.1);
}

.brutalist-button:active .ms-logo {
  transform: rotate(10deg) scale(0.9);
}

.brutalist-button:hover .button-text {
  transform: skew(-5deg);
}

.brutalist-button:active .button-text {
  transform: skew(5deg);
}

.button-text span:first-child {
  font-size: 11px;
  text-transform: uppercase;
}

.button-text span:last-child {
  font-size: 16px;
  text-transform: uppercase;
}

.cards {
  width: 95%;
  height: 230px;
  left: 3%;
  margin-bottom: 10px;
  border-radius: 10px;
  background: #1d90dd;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.cards-list {
  height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.cards::before {
  content: "";
  height: 100px;
  width: 100px;
  position: absolute;
  top: -40%;
  left: -20%;
  border-radius: 50%;
  border: 35px solid rgba(255, 255, 255, 0.102);
  transition: all .8s ease;
  filter: blur(.5rem);
}

.texts {

  flex-grow: 1;
  padding: 15px;
  display: flex;
  flex-direction: column;
  color: aliceblue;
  font-weight: 900;
  font-size: 1.2em;
}

.subtitle {
  font-size: 15px;
  font-weight: 600;
  color: rgba(240, 248, 255, 0.691);
}

.iconss {
  display: flex;
  gap: 10px;
}

.iconss.top-right {
  position: absolute;
  top: 10px;
  right: 10px;
}

.btns {
  border: none;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: rgba(247, 234, 234, 0.589);
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-icons {
  width: 24px;
  height: 24px;
  color: #333; /* Default color */
  transition: transform 0.2s ease-in-out;
}

.btns:hover {
  background-color: rgb(247, 234, 234);
}

.cards:hover::before {
  width: 140px;
  height: 140px;
  top: -30%;
  left: 50%;
  filter: blur(0rem);
}

.amount-and-status {
  display: flex;
  align-items: center;
}

.amount-and-status h1 {
  font-size: 24px;
  font-weight: bold;
}

.status {
  font-size: 18px;
  font-weight: 600;
  color: #555;
}

.radio-inputs {
  margin: 10px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5rem;
  background-color: #eee;
  box-sizing: border-box;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
  padding: 0.25rem;
  width: 300px;
  font-size: 14px;
}

.radio-inputs .radio {
  flex: 1 1 auto;
  text-align: center;
}

.radio-inputs .radio input {
  display: none;
}

.radio-inputs .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: none;
  padding: 0.5rem 0;
  color: rgba(51, 65, 85, 1);
  transition: all 0.15s ease-in-out;
}

.radio-inputs .radio input:checked + .name {
  background-color: #1d90dd;
  color: white;
  font-weight: 600;
}

/* Hover effect */
.radio-inputs .radio:hover .name {
  background-color: rgba(255, 255, 255, 0.5);
}

/* Animation */
.radio-inputs .radio input:checked + .name {
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  animation: select 0.3s ease;
}

@keyframes select {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Particles */
.radio-inputs .radio input:checked + .name::before,
.radio-inputs .radio input:checked + .name::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #3b82f6;
  opacity: 0;
  animation: particles 0.5s ease forwards;
}

.radio-inputs .radio input:checked + .name::before {
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
}

.radio-inputs .radio input:checked + .name::after {
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
}

@keyframes particles {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(0);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(var(--direction));
  }
}

.radio-inputs .radio input:checked + .name::before {
  --direction: -10px;
}

.radio-inputs .radio input:checked + .name::after {
  --direction: 10px;
}

.bin-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border-radius: 15px;
  background-color: rgb(255, 95, 95);
  cursor: pointer;
  border: 3px solid rgb(255, 201, 201);
  transition-duration: 0.3s;
}
.bin-bottom {
  width: 15px;
}
.bin-top {
  width: 17px;
  transform-origin: right;
  transition-duration: 0.3s;
}
.bin-button:hover .bin-top {
  transform: rotate(45deg);
}
.bin-button:hover {
  background-color: rgb(255, 0, 0);
}
.bin-button:active {
  transform: scale(0.9);
}

.container {
  width: 100%;
  max-width: 850px;
  margin: 2rem auto;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.card {
  position: relative;
  padding: 1rem;
  width: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.9rem;
  background-color: var(--red-card);
  color: var(--text);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease;
}

.card-blue {
  background: var(--blue-card);
}

.product-image {
  height: 140px;
  width: 100%;
  overflow: hidden;
  transform: translateY(0);
  transition: transform 500ms ease-in-out;
  filter: drop-shadow(5px 10px 15px rgba(0, 0, 0, 0.3));
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

.card:hover .product-image {
  transform: translateY(-10px) rotate(-3deg);
}

.product-info {
  text-align: center;
}

.product-info h2 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-info p {
  margin: 0.2rem 0;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price {
  font-size: 20px;
  font-weight: 600;
}

.card-body {
  text-align: left;
  font-size: 0.9rem;
  line-height: 1.4;
}

.btn {
  display: flex;
  justify-content: space-between;
  margin-top: 0.8rem;
}

.buy-btn {
  background-color: var(--btn);
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 1rem;
  transition: background-color 300ms ease;
}

.buy-btn:hover {
  background-color: var(--btn-hover);
}

.fav {
  background: #fff;
  padding: 0.5rem;
  border: 1px solid #000;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg {
  height: 25px;
  width: 25px;
  fill: #fff;
  transition: fill 500ms ease;
}

.fav:hover .svg {
  fill: #000;
}

@media screen and (max-width: 768px) {
  .total {
    width: fit-content;
    display:flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items:center;
    gap: 10px
  }
  .container {
    padding: 1rem;
    flex-direction: column;
  }

  .card {
    width: 90%;
  }

  .product-image {
    height: 150px;
  }
}

.row {
  margin-left: 12px;
}

</style>